/* eslint-disable react/react-in-jsx-scope */
import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { Shortcuts } from '@backstage-community/plugin-shortcuts';
import { MyGroupsSidebarItem } from '@backstage/plugin-org';
// import { SidebarLogo } from './SidebarLogo';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import StarsIcon from '@material-ui/icons/Stars';
// import HomeIcon from '@material-ui/icons/Home';
import GroupIcon from '@material-ui/icons/People';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => (
        <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
      ));

      nav.take('page:search');

      return (
        <Sidebar>
          {/* <SidebarLogo /> */}
          <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
            <SidebarSearchModal />
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            {nav.take('page:home')}
            {nav.take('page:catalog')}
            <MyGroupsSidebarItem
              singularTitle="My Group"
              pluralTitle="My Groups"
              icon={GroupIcon}
            />
            {nav.take('page:api-docs')}
            {nav.take('page:techdocs')}
            {nav.take('page:scaffolder')}
            <SidebarDivider />
            <SidebarGroup label="Rithum AI" icon={<StarsIcon />}>
              {nav.take('page:rithum-ai/page:rithum-ai/agents')}
              {nav.take('page:rithum-ai/page:rithum-ai/skills')}
            </SidebarGroup>
            <SidebarDivider />
            <SidebarScrollWrapper>
              <Shortcuts />
              {/* {nav.rest({ sortBy: 'title' })} */}
            </SidebarScrollWrapper>
          </SidebarGroup>
          <SidebarDivider />
          <SidebarSpace />
          <SidebarDivider />
          <NotificationsSidebarItem />
          <SidebarDivider />
          <SidebarGroup
            label="Settings"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            {/* {nav.take('page:app-visualizer')} */}
            {nav.take('page:user-settings')}
          </SidebarGroup>
        </Sidebar>
      );
    },
  },
});
